import type { ExtendedValidationResponse } from "libs/codegen/property-onboarding";
import { useEffect } from "react";
import { useNavigate, useParams } from "router";
import { externalPropertyTypeMapper } from "../urlInput/externalPropertyTypeMapper.ts";
import { usePropertyListing } from "./usePropertyListing.ts";

export const useScrapeProperties = ({ sanitizedUrl, externalPropertyType }: ExtendedValidationResponse) => {
    const { isIdle, mutate, isLoading } = usePropertyListing();
    const navigate = useNavigate();
    const { lang } = useParams("/:lang/list-my-property/get-started/automatic/lists");
    const isRedirecting = !sanitizedUrl?.trim();

    useEffect(() => {
        if (isRedirecting) {
            navigate("/:lang/list-my-property/get-started/automatic", {
                params: { lang },
                replace: true,
            });
            return;
        }
        mutate(sanitizedUrl);
    }, [sanitizedUrl, externalPropertyType, isRedirecting, lang, mutate, navigate]);

    return {
        loading:
            isRedirecting ||
            (externalPropertyType === externalPropertyTypeMapper.Bcom && !isIdle) ||
            (externalPropertyType === externalPropertyTypeMapper.Airbnb && isLoading) ||
            (externalPropertyType === externalPropertyTypeMapper.Rakuten && !isIdle) ||
            (externalPropertyType === externalPropertyTypeMapper.RakutenOyado && isLoading),
    };
};
